import { httpsCallableFromURL } from "firebase/functions";
import { FirebaseWebAuthnError } from "./FirebaseWebAuthnError.js";
export const clearChallenge = (functions) => httpsCallableFromURL(functions, "/firebase-web-authn-api")({
    operation: "clear challenge",
})
    .then(({ data: functionResponse }) => "code" in functionResponse ? (() => {
    throw new FirebaseWebAuthnError(functionResponse);
})() : void (0), (firebaseError) => {
    throw new FirebaseWebAuthnError({
        code: firebaseError.code.replace("firebaseWebAuthn/", ""),
        message: firebaseError.message,
        method: "httpsCallableFromURL",
        operation: "clear challenge",
    });
});
